// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgressBadge_container__1-3nV"};